import { render, staticRenderFns } from "./InvoiceSettings.vue?vue&type=template&id=df68cf04&"
import script from "./InvoiceSettings.vue?vue&type=script&lang=js&"
export * from "./InvoiceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df68cf04')) {
      api.createRecord('df68cf04', component.options)
    } else {
      api.reload('df68cf04', component.options)
    }
    module.hot.accept("./InvoiceSettings.vue?vue&type=template&id=df68cf04&", function () {
      api.rerender('df68cf04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/InvoiceSettings.vue"
export default component.exports